module.exports = __webpack_public_path__ + "static/media/GA-2100FF-8AER_OR14_beautyshot2.5880b4a1.jpg";